import { Maybe } from '@ts/operations'
import React from 'react'

import ReleasePrice from './ReleasePrice'

const priceDescriptionFor = (
  price: DisplayReleasePriceProps['price'],
  displayPriceIncludingTax: boolean,
  displaySubPrice: boolean
) => {
  let description: Maybe<string> = null
  if (!displayPriceIncludingTax && displaySubPrice) {
    description = 'incl. taxes'
  } else if (displayPriceIncludingTax && price.taxLines.length === 1) {
    description = `Excl. ${price.taxLines[0].name}`
  } else if (price.taxLines.length > 1 || (!displayPriceIncludingTax && !displaySubPrice)) {
    description = 'Excl. taxes'
  }
  return description
}

export type DisplayReleasePriceProps = {
  displayPriceIncludingTax: boolean
  displaySubPrice?: boolean
  price: {
    exTax: {
      currency: { symbol: string | null }
      format: string
    }
    taxLines: Array<{
      name: string
    }>
    total: { format: string }
  }
  variant: string
}

const DisplayReleasePrice = ({
  price,
  displayPriceIncludingTax,
  displaySubPrice = true,
  variant,
}: DisplayReleasePriceProps) => {
  const {
    exTax: {
      format: formattedAmount,
      currency: { symbol },
    },
    total: { format: formattedTotalAmount },
  } = price

  return (
    <ReleasePrice
      amountExTax={formattedAmount}
      amountIncTax={formattedTotalAmount}
      description={priceDescriptionFor(price, displayPriceIncludingTax, displaySubPrice)}
      displayPriceIncludingTax={displayPriceIncludingTax}
      displaySubPrice={displaySubPrice}
      symbol={symbol || ''}
      variant={variant}
    />
  )
}

export default DisplayReleasePrice
